<template>
  <div>
    <slot></slot>
    
    <static-string>
      Characters entered: 
    </static-string>
    <span>{{ charCount }} / {{ maxChars }} </span>
   
  </div>
</template>

<script>
import StaticString from '../../admin/statics/StaticString.vue';

export default {
  components: { StaticString },
  
  data() {
    return {
      inputTextLength: null,
      maxCharLimit: 500
    };
  },
  computed: {
    charCount() {
      return this.inputTextLength;
    },
    maxChars(){
      this.maxCharLimit = this.$slots.default[0].data.attrs.maxlength
      return this.maxCharLimit ;
    }
  },

  methods: {
    handleInput(value) {
      this.inputTextLength = value.length;
    }
  },
  
  mounted() {
    this.inputTextLength  = this.$slots.default[0].elm.value.length;

    this.$slots.default[0].elm.addEventListener('input', (event) => {
      this.handleInput(event.target.value);
    })
  
  }
};
</script>
